import { call, put } from 'redux-saga/effects';
import api from '@/services/api';

import AcademicActions, { AcademicTypes } from '@/store/ducks/academic';
import { GLOBAL_CONSTANTS } from '@/utils/globalConstants';
import Toast from '@/utils/toast';
import { getAPIErrorPayload } from '@/utils/commonFunctions';

export function* getAcademicRequest() {
  try {
    const {
      API_URLS: { academicDetails },
    } = GLOBAL_CONSTANTS;
    const { data } = yield call(api.get, academicDetails);
    yield put(AcademicActions.getAcademicSuccess(data?.data ?? []));
  } catch (error) {
    Toast.error(error?.message);
    yield put(AcademicActions.getAcademicFailure(getAPIErrorPayload(AcademicTypes.GET_ACADEMIC_REQUEST, error)));
  }
}
